var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('div',{staticClass:"main-container__menu",class:_vm.menuClasses},_vm._l((_vm.menuItems),function(item,index){return _c('div',{key:index,staticClass:"main-container__menu__item",class:{
        active: _vm.getIsActive(item),
      },attrs:{"id":item.id},on:{"click":function($event){return _vm.onClickItem(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }